var _excluded = ["text", "isBold"],
  _excluded2 = ["data", "typography", "emphasis", "color", "align", "pushSpace", "htmlTag", "hasLineThrough", "hasNoSpace", "lineBreakHeightSpace"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import React, { Fragment } from "react";
import styled, { css } from "styled-components";
import space from "../../../utils/space";
import throwError from "../../../utils/throwError";
import NestedLinkAtm from "../../atoms/NestedLinkAtm";
import TextAtm from "../../atoms/TextAtm";
var StyledTextAtm = styled(TextAtm).withConfig({
  componentId: "sc-1vxfrps-0"
})(function (_ref) {
  var $lineBreakHeightSpace = _ref.$lineBreakHeightSpace;
  return $lineBreakHeightSpace && css(["br{content:\"\";display:block;margin-top:", ";}"], space($lineBreakHeightSpace));
});
var insertText = function insertText(dataText, parentTypography, parentEmphasis, parentColor) {
  if (_typeof(dataText) === "object") {
    if (Object.keys(dataText).length === 1) {
      throwError('Prop "data" as an object must have at least two parameters!');
    }
    if ("to" in dataText || "href" in dataText || "onClick" in dataText) {
      var _text = dataText.text,
        _isBold = dataText.isBold,
        restProps = _objectWithoutProperties(dataText, _excluded);
      return /*#__PURE__*/React.createElement(NestedLinkAtm, _extends({
        isBold: _isBold
      }, restProps), _text);
    }
    var _ref2 = dataText,
      text = _ref2.text,
      emphasis = _ref2.emphasis,
      color = _ref2.color,
      isBold = _ref2.isBold,
      hasLineThrough = _ref2.hasLineThrough,
      hasNonBreakingSpace = _ref2.hasNonBreakingSpace,
      htmlTag = _ref2.htmlTag;
    return /*#__PURE__*/React.createElement(TextAtm, {
      typography: parentTypography,
      emphasis: emphasis !== null && emphasis !== void 0 ? emphasis : parentEmphasis,
      color: color !== null && color !== void 0 ? color : parentColor,
      isBold: isBold,
      hasLineThrough: hasLineThrough,
      hasNonBreakingSpace: hasNonBreakingSpace,
      htmlTag: htmlTag
    }, text);
  }
  return dataText;
};
var insertLine = function insertLine(line, typography, emphasis, color, hasNextLine, hasNoSpace) {
  return line.map(function (text, index) {
    var hasNextWord = index !== line.length - 1;
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React.createElement(Fragment, {
        key: index
      }, insertText(text, typography, emphasis, color), hasNextWord && !hasNoSpace ? " " : null, !hasNextWord && hasNextLine ? /*#__PURE__*/React.createElement("br", null) : null)
    );
  });
};
function RichTextMol(_ref3) {
  var data = _ref3.data,
    typography = _ref3.typography,
    emphasis = _ref3.emphasis,
    color = _ref3.color,
    align = _ref3.align,
    pushSpace = _ref3.pushSpace,
    htmlTag = _ref3.htmlTag,
    hasLineThrough = _ref3.hasLineThrough,
    hasNoSpace = _ref3.hasNoSpace,
    lineBreakHeightSpace = _ref3.lineBreakHeightSpace,
    restProps = _objectWithoutProperties(_ref3, _excluded2);
  if (Array.isArray(data) && data.length === 1) {
    throwError('Prop "data" as an array must have at least two elements!');
  }
  var newData;
  if (!Array.isArray(data)) {
    newData = [data];
  } else {
    newData = data;
  }
  return /*#__PURE__*/React.createElement(StyledTextAtm, _extends({
    typography: typography,
    emphasis: emphasis,
    color: color,
    align: align,
    pushSpace: pushSpace,
    htmlTag: htmlTag,
    hasLineThrough: hasLineThrough,
    $lineBreakHeightSpace: lineBreakHeightSpace
  }, restProps), Array.isArray(newData[0]) ? newData.map(function (line, index) {
    var hasNextLine = index !== newData.length - 1;
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React.createElement(Fragment, {
        key: index
      }, insertLine(line, typography, emphasis, color, hasNextLine, !!hasNoSpace))
    );
  }) : insertLine(newData, typography, emphasis, color, false, !!hasNoSpace));
}
export default RichTextMol;